import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../../services/ApiService";
import DatePicker from "react-datepicker";

export default function EditExpenditure({
  closeModal,
  getExpenditures,
  value,
  alert,
}) {
  console.log(value);
  return (
    <React.Fragment>
      <h4 style={{ color: "#000" }}>Edit Office Asset</h4>
      <Formik
        initialValues={{
          description: value.description,
          price: value.price,
          request_id: value.request_id,
          request_type: value.request_type,
          request_category: value.request_category,
          expenditure_date: new Date(value.date),
          request: value.request_id,
        }}
        onSubmit={(values, { setSubmitting }) => {
          values.expenditure_date = new Date(
            values.expenditure_date.getTime() +
              Math.abs(values.expenditure_date.getTimezoneOffset() * 60000)
          );
          ApiService.post(`expenditures/${value.expenditure_id}`, values).then(
            (res) => {
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
              }
              getExpenditures();
              closeModal();
            }
          );
        }}
      >
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    {" "}
                    Date <span className="text-danger"> * </span>
                  </label>
                  <DatePicker
                    selected={values.expenditure_date}
                    minDate={new Date()}
                    showDisabledMonthNavigation
                    dateFormat="MMMM d, yyyy"
                    className="form-control"
                    name="start_date"
                    autoComplete="off"
                    onChange={(date) => setFieldValue("expenditure_date", date)}
                    required
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Price <span className="text-danger"> * </span>
                  </label>
                  <Field type="number" className="form-control" name="price" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>Description</label>
                  <Field
                    name="description"
                    as="textarea"
                    cols="10"
                    rows="5"
                    className="form-control"
                  ></Field>
                </div>
              </div>
            </div>

            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-8">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Update
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/expenditure/modal/edit_expenditure.js